import { linkedSignal, Signal, WritableSignal } from '@angular/core';

export function linkedListSignal<T = any>(source: Signal<T[]>): WritableSignal<T[]> {
  return linkedSignal({
    source,
    computation: (source, previous): T[] =>
      Array.isArray(previous?.source) ? previous?.source : (Array.isArray(source) ? source : previous?.value || [])
  });
}
